import _ from 'lodash'
import Backbone from 'backbone'
import template from './mass-edit-buttons.hbs'
import BusyButton from 'scoreboard/components/busy-button'

var MassEditButtons = Backbone.View.extend({
	tagName: 'span',
	className: 'mass-edit-buttons save-cancel button-group-nowrap',

	initialize: function(options) {
		this.options = options
	},

	render: function() {
		this.$el.empty().append(template())
		this.$('.edit-selected-items').addClass('button-primary')
		this.busyButton = new BusyButton({ el: this.$('.edit-selected-items') })
		// hide the save button (not implemented yet)
		this.$('.mass-edit-save').addClass('is-not-displayed')
		return this
	},

	toggleEditSelectedItemsButton: function(anySelected) {
		this.$('.edit-selected-items').prop('disabled', !anySelected)
	},

	dialogOpening: function() {
		this.busyButton.loading()
	},

	dialogOpened: function() {
		this.busyButton.done()
	},

	dialogComplete: function() {
		this.busyButton.enable()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.busyButton], 'remove')
	}

})

export default MassEditButtons

MassEditButtons.__filename__ = 'admin/mass-edit/mass-edit-buttons.js'
